import React from 'react';
import PageMeta from '../../components/common/PageMeta';
import FooterOne from '../../layout/Footer/FooterOne';
import Navbar from '../../layout/Header/Navbar';
import Layout from '../../layout/Layout';
import CancellationHeroSection from './cancellationHeroSection';

const CancellationAndRefundPolicy = () => {
    return (
        <Layout >
            <div
                style={{ background: "radial-gradient(75% 25% at 50% 0%, rgb(216 223 235), rgb(255, 255, 255))" }}
            >
                <PageMeta />
                <Navbar />

                <section
                    className='page-header position-relative overflow-hidden pt-60 pb-60 '
           
                >
                    <div className='container'>
                        <div className='row justify-content-center'>
                            <div className='col-lg-12 col-md-12'>
                                <div className='text-center'>
                                    <h1 className=' fw-bold'>Cancellation & refund policy</h1>
                                    <p className='lead'>
                                        Senertech Software Private Limited (“we,” “us,” “our,” or the “company”) is engaged in the business of delivering IT services and developing cloud-based software applications under the brand name “Senertech”. Our products are designed to serve a variety of industries and businesses through a suite of proprietary software applications (collectively referred to as the “Senertech Apps” or “Apps”). </p>
                                        <p className='lead'>The company is the creator and owner of the apps and provides access to them through various subscription-based models, subject to the payment of a corresponding subscription fee. Users may choose from a range of available subscription plans and complete the purchase using one of the supported payment methods.</p>
                                        <p className='lead'>Access to and use of the apps, as well as any related value-added services offered by us under a subscription plan (the “subscription”), is governed by our Terms of Service. These terms must be accepted by you, defined as any individual or entity who accesses or uses the apps at the time of subscription.</p> 
                                </div>
                            </div>
                        </div>

                    </div>
                </section>

                <CancellationHeroSection />
                <FooterOne
                    style={{
                        background:
                            "url('assets/img/page-header-bg.svg')no-repeat bottom left",
                    }}
                />
            </div>
        </Layout>
    );
};

export default CancellationAndRefundPolicy;
